module.exports = __webpack_public_path__ + "img/sales-paused.aa469220.svg";